var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8921 1.75H2.64209C1.9459 1.75 1.27822 2.02656 0.785935 2.51884C0.293652 3.01113 0.0170898 3.67881 0.0170898 4.375L0.0170898 23.625C0.0170898 24.3212 0.293652 24.9889 0.785935 25.4812C1.27822 25.9734 1.9459 26.25 2.64209 26.25H10.1479V17.9205H6.70264V14H10.1479V11.0119C10.1479 7.61305 12.1714 5.73562 15.2705 5.73562C16.7547 5.73562 18.3068 6.00031 18.3068 6.00031V9.33625H16.5967C14.9118 9.33625 14.3862 10.3819 14.3862 11.4543V14H18.1476L17.5461 17.9205H14.3862V26.25H21.8921C22.5883 26.25 23.256 25.9734 23.7482 25.4812C24.2405 24.9889 24.5171 24.3212 24.5171 23.625V4.375C24.5171 3.67881 24.2405 3.01113 23.7482 2.51884C23.256 2.02656 22.5883 1.75 21.8921 1.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.5,
    height: 28,
    fill: "white",
    transform: "translate(0.0170898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.826ade85de5e00c4acc6f9f3ef351d20.svg";
export { ForwardRef as ReactComponent };